/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBriefcase2 = createReactComponent("briefcase-2", "IconBriefcase2", [
  [
    "path",
    {
      d: "M3 9a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M8 7v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2", key: "svg-1" }]
]);

export { IconBriefcase2 as default };
//# sourceMappingURL=IconBriefcase2.js.map
